export const checkIfItsTouchDevice = () => window.matchMedia("(pointer: coarse)").matches;